import { render, staticRenderFns } from "./PastizalConvertidoACultivoParaguay.vue?vue&type=template&id=7f593c85&lang=pug"
import script from "./PastizalConvertidoACultivoParaguay.vue?vue&type=script&lang=js"
export * from "./PastizalConvertidoACultivoParaguay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports